/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmployee201Response
 */
export interface CreateEmployee201Response {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployee201Response
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof CreateEmployee201Response
     */
    position: number;
}

/**
 * Check if a given object implements the CreateEmployee201Response interface.
 */
export function instanceOfCreateEmployee201Response(value: object): value is CreateEmployee201Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function CreateEmployee201ResponseFromJSON(json: any): CreateEmployee201Response {
    return CreateEmployee201ResponseFromJSONTyped(json, false);
}

export function CreateEmployee201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployee201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'position': json['position'],
    };
}

export function CreateEmployee201ResponseToJSON(json: any): CreateEmployee201Response {
    return CreateEmployee201ResponseToJSONTyped(json, false);
}

export function CreateEmployee201ResponseToJSONTyped(value?: CreateEmployee201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'position': value['position'],
    };
}

